import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { Tabs } from '@factorialco/f0-react/dist/experimental'

import Loading from 'modules/core/components/Loading'
import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import Comments from './Comments'
import Documents from './Documents'

interface Props {
  payrollRunId: number
  hasProfessionals: boolean
  onClose: () => void
}

export const ActivitySidepanel = ({ payrollRunId, hasProfessionals, onClose }: Props) => {
  const loading = false
  const [activeTab, setActiveTab] = useState<'messages' | 'documents'>('messages')

  const SidebarTitle = (
    <Box alignItems="center" justifyContent="center" flexDirection="row" flexGrow>
      <Text.Normal weight="semibold">Activity</Text.Normal>
    </Box>
  )

  if (loading) {
    return (
      <Sidepanel onClose={onClose} title={SidebarTitle}>
        <Loading />
      </Sidepanel>
    )
  }
  return (
    <Sidepanel
      title={loading ? null : SidebarTitle}
      width="wide"
      closeLabel={i18n.t('common.close')}
      onClose={onClose}
      open
      boxPadding={false}
    >
      {loading ? (
        <Loading />
      ) : hasProfessionals ? (
        <>
          <Box paddingTop="s12">
            <Tabs
              activeTabId={activeTab}
              tabs={[
                {
                  index: true,
                  id: 'messages',
                  label: i18n.t(
                    'compensations.PayrollRunCompensationsList.activity_sidepanel.comments_tab_title'
                  ),
                  onClick: () => {
                    setActiveTab('messages')
                  },
                },
                {
                  index: true,
                  id: 'documents',
                  label: i18n.t(
                    'compensations.PayrollRunCompensationsList.activity_sidepanel.documents_tab_title'
                  ),
                  onClick: () => {
                    setActiveTab('documents')
                  },
                },
              ]}
            ></Tabs>
          </Box>
          {activeTab === 'messages' && <Comments payrollRunId={payrollRunId} />}
          {activeTab === 'documents' && (
            <Documents payrollRunId={payrollRunId} hasProfessionals={hasProfessionals} />
          )}
        </>
      ) : (
        <Documents payrollRunId={payrollRunId} hasProfessionals={hasProfessionals} />
      )}
    </Sidepanel>
  )
}
